export const mainPageInitialState = {
  mainPageData: null,
  isDataLoaded: false,
  isLoading: false,
  isError: "",
};
